import { formatINRCompact } from '../../utils/formatters';

export function GSTSummaryWidget({ byStatus }) {
  const rows = byStatus || [];
  if (!rows.length) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <h3 className="text-sm font-semibold text-slate-800">GST reconciliation</h3>
        <p className="mt-2 text-sm text-slate-500">No GST data</p>
      </div>
    );
  }

  const max = Math.max(...rows.map((r) => r.cnt || 0), 1);

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-slate-800">GST reconciliation</h3>
      <ul className="space-y-3">
        {rows.map((r) => (
          <li key={r.status}>
            <div className="mb-1 flex justify-between text-xs font-medium text-slate-600">
              <span>{r.status}</span>
              <span>
                {r.cnt} · {formatINRCompact(r.amount)}
              </span>
            </div>
            <div className="h-2 overflow-hidden rounded-full bg-slate-100">
              <div
                className="h-full rounded-full bg-blue-600"
                style={{ width: `${Math.min(100, ((r.cnt || 0) / max) * 100)}%` }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
